export const isIOS = (): boolean => {
  if (typeof navigator === "undefined") return false
  const ua = navigator.userAgent || ""
  const platform = typeof navigator.platform === "string" ? navigator.platform : ""
  const iOSLike = /iPhone|iPad|iPod/.test(ua) || /iP(hone|ad|od)/.test(platform)
  const macTouch = /Macintosh/.test(ua) && typeof document !== "undefined" && "ontouchend" in document
  return iOSLike || macTouch
}

const IOS_VERSION_REGEX = /(?:OS|CPU OS) (\d+)[._](\d+)?/

export const getIOSMajorVersion = (): number | null => {
  if (typeof navigator === "undefined") return null
  const ua = navigator.userAgent || ""
  const match = ua.match(IOS_VERSION_REGEX)
  if (!match) return null
  const major = Number.parseInt(match[1], 10)
  return Number.isNaN(major) ? null : major
}

export const isIOSVersionAtLeast = (majorVersion: number): boolean => {
  const current = getIOSMajorVersion()
  if (current === null) return false
  return current >= majorVersion
}
